import React from 'react';
import styles from './region-entity-table.module.scss';
import { EntityTableHeader } from './entity-table-header';
import { humanizeNumber } from '../../helpers/formatters';
import { entityLabelMatcher } from '../../helpers/label-mapper';
import { connect } from 'react-redux';
import * as selectors from '../../reducers';
import PropTypes from 'prop-types';
import {
  setActiveRegion,
  setComparedRegion,
  setActivePage,
} from '../../actions/ui';
import { ArrowRight } from '../../components/icons';

const EntityTableComponent = ({
  entity,
  setActiveRegion,
  setComparedRegion,
  setActivePage,
  isMobile,
}) => {
  const key = 'region';
  const regionGroups = Object.keys(
    groupBy(entity.byRegionByEntity, 'highLevelClassification')
  ).sort();
  return (
    <div style={{ width: '100%' }}>
      <div
        style={{
          width: '100%',
          overflow: 'auto',
          paddingLeft: isMobile ? 20 : 0,
        }}
      >
        <table className={styles.entityRegionTable} style={{ maxWidth: 800 }}>
          <tbody>
            <EntityTableHeader entity={entity} comparing={false} />
            {regionGroups.map((groupName, i) => {
              const regionsInClass = entity.byRegionByEntity.filter(
                (x) => x.highLevelClassification === groupName
              );
              const numRegionsService = regionsInClass.filter(
                (x) =>
                  !isNaN(x.averageOfRtpAnnualisedServiceCharge) &&
                  x.averageOfRtpAnnualisedServiceCharge !== ''
              ).length;
              const numRegionsConsumption = regionsInClass.filter(
                (x) =>
                  !isNaN(x.averageOfRtpAnnualisedServiceCharge) &&
                  x.averageOfRtpAnnualisedServiceCharge !== ''
              ).length;

              const classCapacityMl = regionsInClass
                .filter((x) => !isNaN(x.capacityMl) && x.capacityMl !== '')
                .reduce((acc, curr) => acc + curr.capacityMl, 0);
              const classDams = regionsInClass
                .filter((x) => !isNaN(x.dams) && x.dams !== '')
                .reduce((acc, curr) => acc + curr.dams, 0);
              const classStorageLevelMin = Math.min.apply(
                Math,
                regionsInClass
                  .filter(
                    (x) => !isNaN(x.storageLevel) && x.storageLevel !== ''
                  )
                  .map(function (x) {
                    return x.storageLevel;
                  })
              );
              const classStorageLevelMax = Math.max.apply(
                Math,
                regionsInClass
                  .filter(
                    (x) => !isNaN(x.storageLevel) && x.storageLevel !== ''
                  )
                  .map(function (x) {
                    return x.storageLevel;
                  })
              );
              const classAverageOfRtpAnnualisedServiceCharge =
                numRegionsService > 0
                  ? regionsInClass
                      .filter(
                        (x) =>
                          !isNaN(x.averageOfRtpAnnualisedServiceCharge) &&
                          x.averageOfRtpAnnualisedServiceCharge !== ''
                      )
                      .reduce(
                        (acc, curr) =>
                          acc + curr.averageOfRtpAnnualisedServiceCharge,
                        0
                      ) / numRegionsService
                  : '-';
              const classAverageOfRtpConsumptionCharge =
                numRegionsConsumption > 0
                  ? regionsInClass
                      .filter(
                        (x) =>
                          !isNaN(x.averageOfRtpConsumptionCharge) &&
                          x.averageOfRtpConsumptionCharge !== ''
                      )
                      .reduce(
                        (acc, curr) => acc + curr.averageOfRtpConsumptionCharge,
                        0
                      ) / numRegionsConsumption
                  : '-';

              return regionsInClass
                ? [
                    <tr className={styles.regionGroupRow} key={groupName + i}>
                      <td className={styles.regionGroupName}>
                        <h4>
                          {entityLabelMatcher(groupName, 'plural') +
                            ' (' +
                            regionsInClass.length +
                            ')'}
                        </h4>
                      </td>
                      <td
                        className={[styles.numberCell, styles.regionGroupValue]}
                      >
                        {classCapacityMl > 0
                          ? humanizeNumber(classCapacityMl, 'ml')
                          : '-'}
                      </td>
                      <td
                        className={[styles.numberCell, styles.regionGroupValue]}
                      >
                        {classDams > 0 ? classDams : '-'}
                      </td>
                      <td
                        className={[styles.numberCell, styles.regionGroupValue]}
                      >
                        {isFinite(classStorageLevelMin) &&
                        isFinite(classStorageLevelMax)
                          ? humanizeNumber(
                              classStorageLevelMin / 100,
                              'percentage'
                            ) +
                            '-' +
                            humanizeNumber(
                              classStorageLevelMax / 100,
                              'percentage'
                            )
                          : '-'}
                      </td>
                      <td
                        className={[styles.numberCell, styles.regionGroupValue]}
                      >
                        {classAverageOfRtpAnnualisedServiceCharge > 0
                          ? humanizeNumber(
                              classAverageOfRtpAnnualisedServiceCharge,
                              'currency',
                              1
                            )
                          : '-'}
                      </td>
                      <td
                        className={[styles.numberCell, styles.regionGroupValue]}
                      >
                        {classAverageOfRtpConsumptionCharge > 0
                          ? humanizeNumber(
                              classAverageOfRtpConsumptionCharge,
                              'currency',
                              1
                            )
                          : '-'}
                      </td>
                    </tr>,
                    regionsInClass
                      .sort((a, b) =>
                        a.region < b.region ? -1 : a.region > b.region ? 1 : 0
                      )
                      .map((entityRegion, i) => {
                        const isClickable = !entityRegion.region.includes(
                          'Other'
                        );
                        return (
                          <tr
                            className={styles.regularTableRow}
                            key={entityRegion + i}
                          >
                            <td
                              onClick={() => {
                                if (isClickable) {
                                  setActiveRegion(entityRegion[key]);
                                  setComparedRegion(null);
                                  setActivePage(key);
                                }
                              }}
                              data-clickable={isClickable}
                              style={{ maxWidth: 300 }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                }}
                              >
                                <div>
                                  {isClickable
                                    ? entityRegion[key]
                                    : entityRegion[key] + ' *'}
                                </div>
                                {!isClickable && (
                                  <div className={styles.cellInfoText}>
                                    *PLACEHOLDER
                                  </div>
                                )}
                              </div>
                            </td>
                            <td className={styles.numberCell}>
                              {humanizeNumber(entityRegion.capacityMl, 'ml')}
                            </td>
                            <td className={styles.numberCell}>
                              {entityRegion.dams}
                            </td>
                            <td className={styles.numberCell}>
                              {humanizeNumber(
                                entityRegion.storageLevel / 100,
                                'percentage'
                              )}
                            </td>
                            <td className={styles.numberCell}>
                              {humanizeNumber(
                                entityRegion.averageOfRtpAnnualisedServiceCharge,
                                'currency',
                                1
                              )}
                            </td>
                            <td className={styles.numberCell}>
                              {humanizeNumber(
                                entityRegion.averageOfRtpConsumptionCharge,
                                'currency',
                                1
                              )}
                            </td>
                          </tr>
                        );
                      }),
                  ]
                : null;
            })}
          </tbody>
        </table>
      </div>
      {isMobile && regionGroups.length > 0 && (
        <div style={{ textAlign: 'left', paddingLeft: 20, marginTop: 20 }}>
          <span className={styles.cellInfoText}>
            Scroll the table to see more
          </span>
          <ArrowRight
            fill="blue"
            width="10px"
            height="10px"
            style={{ marginLeft: 10 }}
          />
        </div>
      )}
      {/*<div style={{ maxWidth: 800, marginLeft: "auto", marginRight: "auto" }}><InfoNotice entityOrRegion={entity} /></div>*/}
    </div>
  );
};

var groupBy = function (xs, key) {
  return xs.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

const mapDispatchToProps = {
  setActiveRegion,
  setComparedRegion,
  setActivePage,
};

const mapStateToProps = (state, props) => ({
  isMobile: selectors.getIsMobile(state),
});

EntityTableComponent.propTypes = {
  entity: PropTypes.object,
  setActiveRegion: PropTypes.func,
  setActivePage: PropTypes.func,
  setComparedRegion: PropTypes.func,
};

const EntityTable = connect(
  mapStateToProps,
  mapDispatchToProps
)(EntityTableComponent);
export { EntityTable };



// WEBPACK FOOTER //
// ./src/components/region-entity-table/entity-table.js